module.exports = __webpack_public_path__ + "img/05_1_2_3.b4a01fbf.png";